import * as dashBoardActionCreator from "./dashBoardActionCreator";

export function defaultDashBoardListState() {
    return {
        loading: false,
        response: null,
        error: null
    }
}

export const DashboardListReducer = (state, action) => {
    if (
        !state || 
        action.type === dashBoardActionCreator.DASHBOARD_ACTION.RESET_DASHBOARD_STATE
    ) {
        return { ...state, ...defaultDashBoardListState() };
    }

    if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.REQUEST_DASHBOARD_LIST){
        return { ...state, loading:true};
    }

    if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.RESPONSE_DASHBOARD_LIST) {
        return { ...state, response: action.data, loading:false}
    }

    if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.ERROR_DASHBOARD_LIST) {
        return { ...state , error:action.data, loading:false}
    }
    return state;
 };

 export function defaultDashboardMonthlyHours() {
    return {
        loading: false,
        response: null,
        error: null
    }
 }

 export const DashboardMonthlyHoursReducer = (state, action) => {

if(!state || 
    action.type === dashBoardActionCreator.DASHBOARD_ACTION.RESET_DASHBOARD_MONTHLYHOURS_STATE
){
    return {...state, ...defaultDashboardMonthlyHours()};
}

if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.REQUEST_DASHBOARD_MONTHLYHOURS) {
    return { ...state , loading: true};
}

if( action.type === dashBoardActionCreator.DASHBOARD_ACTION.RESPONSE_DASHBOARD_MONTHLYHOURS) {
    return { ...state, response: action.data, loading:false}
}

if( action.type ===  dashBoardActionCreator.DASHBOARD_ACTION.ERROR_DASHBOARD_MONTHLYHOURS) {
    return {...state, error: action.data , loading: false}
}
return state;
 }
 

 export function defaultEmpDashBoardListState() {
    return {
        loading: false,
        response: null,
        error: null
    }
}

export const EmpDashboardListReducer = (state, action) => {
    if (
        !state || 
        action.type === dashBoardActionCreator.DASHBOARD_ACTION.RESET_EMP_DASHBOARD_STATE
    ) {
        return { ...state, ...defaultEmpDashBoardListState() };
    }    

    if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.REQUEST_EMP_DASHBOARD_LIST){
        return { ...state, loading:true};
    }

    if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.RESPONSE_EMP_DASHBOARD_LIST) {
        return { ...state, response: action.data, loading:false}
    }

    if ( action.type === dashBoardActionCreator.DASHBOARD_ACTION.ERROR_EMP_DASHBOARD_LIST) {
        return { ...state , error:action.data, loading:false}
    }
    return state;
        
    }